import { wrapInput } from '@danderson00/react-forms'
import { Body, Box, Checkbox as CheckboxWidget } from '../widgets'

export const Checkbox = wrapInput(
  ({ name, checked, onChange, title, dark, error }) => (
    <Box gap={8} alignItems="center" onClick={() => onChange(!checked)} cursor="pointer">
      <CheckboxWidget name={name} checked={checked} dark={dark} error={error} onChange={onChange} />
      <Body lineHeight={1.7}>{title}</Body>
    </Box>
  ),
  {
    type: 'checkbox',
    valueFromEvent: x => x
  }
)